/**
 * DirectionalLight2D Component
 *
 * Infinite parallel light (sunlight/moonlight) affecting the entire scene.
 * Supports color and temperature emission modes.
 */

import {
  component,
  displayName,
  icon,
  color,
  category,
  allowMultiple,
  field,
  executeInEditor,
  customEditor,
} from "../attributes";

@component("core.DirectionalLight2D")
@customEditor("DirectionalLight2DEditor")
@displayName("Directional Light 2D")
@icon("Sun")
@color("#ffe066")
@category("Lighting")
@allowMultiple(false)
@executeInEditor(true)
export class DirectionalLight2D {
  // ── Emission Mode ──
  @field({ type: "string", label: "Emission Mode", tooltip: "Color (direct RGB) or Temperature (Kelvin)" })
  emissionMode: string = "color";

  // ── Color Mode ──
  @field({ type: "color", label: "Color", tooltip: "Light color (linear). Used in Color mode." })
  color: { r: number; g: number; b: number; a: number } = { r: 255, g: 255, b: 255, a: 255 };

  // ── Temperature Mode ──
  @field({ type: "f32", label: "Temperature", min: 1000, max: 40000, step: 50, tooltip: "Color temperature in Kelvin (1000K warm → 40000K cool)" })
  temperature: number = 6500;

  @field({ type: "f32", label: "Tint", min: -1, max: 1, step: 0.01, tooltip: "Green–Magenta tint offset (−1 green, +1 magenta)" })
  tint: number = 0;

  // ── Shared ──
  @field({ type: "f32", label: "Intensity", min: 0, max: 100, step: 0.1 })
  intensity: number = 1.0;

  @field({ type: "vec2", label: "Direction", tooltip: "Light direction (will be normalized)" })
  direction: { x: number; y: number } = { x: 0, y: -1 };

  @field({ type: "bool", label: "Enabled" })
  enabled: boolean = true;

  @field({ type: "bool", label: "Cast Shadows" })
  castShadows: boolean = false;
}
